<template>
  <div class="pkdropmenu d-block d-lg-none">
    <div class="titles">
      <div class="in_titles in_titles_menu">
        <div class="in_titles_left" @click="showmenulist = !showmenulist">
          <img class="in_titles_left_img" src="../../assets/images/industry/tb.png" alt="">
          <div><span style="margin-right: 10px;">&gt;</span><span style="font-size: 18px;">{{ pkname }} <i
                class="bi bi-caret-down-fill"></i></span>
          </div>
        </div>
      </div>
    </div>

    <div class="in_titles_right_menulist" :class="{ ind10: type }" v-if="showmenulist">

      <div v-if="pktype == 'abousus'">
        <a href="#aboutNum" :class="val == '1' ? 'changes' : ''" @click="titleRouter('about', '1')">公司介绍</a>
        <a href="#historyLine" :class="val == '2' ? 'changes' : ''" @click="titleRouter('about', '2')">历史沿革</a>
        <a href="#honorSwipe" :class="val == '3' ? 'changes' : ''" @click="titleRouter('about', '3')">荣誉与资质</a>
        <a :class="val == 'parent' ? 'changes' : ''" @click="titleRouter('parent')">生态伙伴</a>
        <a :class="val == '4' ? 'changes' : ''" href="#join_us" @click="titleRouter('about', '4')">加入我们</a>
        <a :class="val == 'info' ? 'changes' : ''" @click="titleRouter('info')">最新资讯</a>
      </div>
      <div v-if="pktype == 'industry'">
        <a :class="type == '1' ? 'changes' : ''" @click="chagnerouter(1)">制造行业</a>
        <a :class="type == '2' ? 'changes' : ''" @click="chagnerouter(2)">建筑与地产行业</a>
        <a :class="type == '3' ? 'changes' : ''" @click="chagnerouter(3)">服务行业</a>
        <a :class="type == '4' ? 'changes' : ''" @click="chagnerouter(4)">公共服务行业</a>
        <a :class="type == '5' ? 'changes' : ''" @click="chagnerouter(5)">能源与矿业行业</a>
        <a :class="type == '6' ? 'changes' : ''" @click="chagnerouter(6)">金融行业</a>
      </div>
      <div v-if="pktype == 'counter'">
        <a :class="type == '1' ? 'changes' : ''" @click="chagnerouter('1')">智慧业财一体化云</a>
        <a :class="type == '2' ? 'changes' : ''" @click="chagnerouter('2')">智慧财务共享(中台)云</a>
        <a :class="type == '3' ? 'changes' : ''" @click="chagnerouter('3')">税务管理云</a>
        <a :class="type == '4' ? 'changes' : ''" @click="chagnerouter('4')">全球司库管理云</a>
        <a :class="type == '5' ? 'changes' : ''" @click="chagnerouter('5')">智慧网银云</a>
        <a :class="type == '6' ? 'changes' : ''" @click="chagnerouter('6')">全面预算管理云</a>
        <a :class="type == '7' ? 'changes' : ''" @click="chagnerouter('7')">智能分析云</a>
      </div>
      <div v-if="pktype == 'portfolio'">
        <a :class="type == '1' ? 'changes' : ''" @click="chagnerouter('1')">智能合同管理平台</a>
        <a :class="type == '2' ? 'changes' : ''" @click="chagnerouter('2')">智慧业财管理平台</a>
        <a :class="type == '3' ? 'changes' : ''" @click="chagnerouter('3')">智能决策与分析经营管理平台</a>
        <a :class="type == '4' ? 'changes' : ''" @click="chagnerouter('4')">智能核算</a>
      </div>
			<div v-if="pktype == 'joinpartners'">
				<a href="#aboutNum" :class="val == '1' ? 'changes' : ''" @click="titleRouter('about')">公司介绍</a>
				<a href="#historyLine" :class="val == '2' ? 'changes' : ''" @click="titleRouter('about')">历史沿革</a>
				<a href="#honorSwipe" :class="val == '3' ? 'changes' : ''" @click="titleRouter('about')">荣誉与资质</a>
				<a :class="val == 'parent' ? 'changes' : ''" @click="titleRouter('parent')" >生态伙伴</a>
				<a :class="val == '4' ? 'changes' : ''" href="#join_us" @click="titleRouter('about')">加入我们</a>
				<a :class="val == 'info' ? 'changes' : ''" @click="titleRouter('info')" >最新资讯</a>
			</div>
			<div v-if="pktype == 'callus'">
				<a class="changes" @click="titleRouter('info')">最新资讯</a>
			</div>
			<div v-if="pktype == 'information'">
				<a href="#aboutNum" :class="val == '1' ? 'changes' : ''" @click="titleRouter('about')">公司介绍</a>
				<a href="#historyLine" :class="val == '2' ? 'changes' : ''" @click="titleRouter('about')">历史沿革</a>
				<a href="#honorSwipe" :class="val == '3' ? 'changes' : ''" @click="titleRouter('about')">荣誉与资质</a>
				<a :class="val == 'parent' ? 'changes' : ''" @click="titleRouter('parent')" >生态伙伴</a>
				<a :class="val == '4' ? 'changes' : ''" href="#join_us" @click="titleRouter('about')">加入我们</a>
				<a :class="val == 'info' ? 'changes' : ''" @click="titleRouter('info')" >最新资讯</a>
			</div>
      
			<div v-if="pktype == 'dataAgent'">
				<a :class="type == '1' ? 'changes' : ''" @click="chagnerouter('1')">AI元生平台</a>
				<a :class="type == '2' ? 'changes' : ''" @click="chagnerouter('2')">元生|DataAgent</a>
				<a :class="type == '3' ? 'changes' : ''" @click="chagnerouter('3')">AI审核</a>
				<a :class="type == '4' ? 'changes' : ''" @click="chagnerouter('4')">AI合同审核</a>
				<a :class="type == '5' ? 'changes' : ''" @click="chagnerouter('5')">AI智慧网银</a>
				<a :class="type == '6' ? 'changes' : ''" @click="chagnerouter('6')">AI报账</a>
			</div>
      
    </div>
  </div>

</template>

<script>
export default {
  props: {
    pkname: {
      type: String,
      default: '',
    },
    pktype: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showmenulist: false,
      val: '',
    }
  },
  methods: {
    titleRouter(type, val) {
      if (type == 'info') {
        this.$router.push({
          path: '/information'
        })
      }
      if (type == 'parent') {
        this.$router.push({
          path: '/join-partners'
        })
      }
			if (type == 'about') {
        this.$router.push({
          path: '/about-us'
        })
      }
      this.val = val
    },
    chagnerouter(types) {
      console.log(types);
      this.$emit('func', types)
      this.showmenulist = !this.showmenulist
    },
  }
}
</script>

<style lang="scss">
.pkdropmenu {
  position: relative;
	.in_titles_menu {
		padding: 0 10px !important
	}
	
	.in_titles_right_menulist {
		min-width: 150px;
		border: 1px solid rgba(0, 0, 0, 0.176);
		position: absolute;
		top: 65px;
		left: 65px;
		z-index: 99;
		background: #fff;
		padding: 10px
	}
	
	.in_titles_right_menulist a {
		display: block;
		color: #333;
		line-height: 50px
	}
	
	.ind10 {
		z-index: 10;
	}
  .changes {
    color: #186BB3;
    border-bottom: 4px solid #186BB3;
  }
}

.pkdropmenu .in_titles_menu {
  width: 100% !important;
  display: flex;
}

</style>
